/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedentary (little/no exercise)`)
};

const es_bmr_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedentario (poco/ningún ejercicio)`)
};

const de_bmr_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzend (wenig/keine Bewegung)`)
};

const nl_bmr_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedentair (weinig/geen oefening)`)
};

const fr_bmr_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sédentaire (peu ou pas d'exercice)`)
};

const it_bmr_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedentario (poco/nessun esercizio)`)
};

const pt_br2_bmr_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedentário (pouco/nenhum exercício)`)
};

const pt_bmr_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedentário (pouco/nenhum exercício)`)
};

const ja_bmr_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`座りがち（運動なし/少ない）`)
};

const zh_bmr_act_sedentary = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`久坐（很少或不运动）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_act_sedentary = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_act_sedentary(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_act_sedentary", locale)
	if (locale === "en") return en_bmr_act_sedentary(inputs)
	if (locale === "es") return es_bmr_act_sedentary(inputs)
	if (locale === "de") return de_bmr_act_sedentary(inputs)
	if (locale === "nl") return nl_bmr_act_sedentary(inputs)
	if (locale === "fr") return fr_bmr_act_sedentary(inputs)
	if (locale === "it") return it_bmr_act_sedentary(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_act_sedentary(inputs)
	if (locale === "pt") return pt_bmr_act_sedentary(inputs)
	if (locale === "ja") return ja_bmr_act_sedentary(inputs)
	return zh_bmr_act_sedentary(inputs)
};